import React from "react";
import Resume from "./Resume";

const NavBar = () => {
  const ResumeBtn=()=>{
    window.open("./media/resume-krishna.pdf","_blank");
  }
  return (
    <>
      <nav className="navbar navbar-expand-lg bg-body-tertiary fixed-top">
        <div className="container">
          <span className="navbar-brand logo">Krishna</span>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className="collapse navbar-collapse justify-content-end"
            id="navbarSupportedContent"
          >
            {/* <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
        <li className="nav-item">
          <a className="nav-link active" aria-current="page" href="/">Home</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="/">Link</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="/">Link</a>
        </li> 
        <li className="nav-item">
          <a className="nav-link" href="/">Link</a>
        </li>
        <li className="nav-item">
        <button className="btn btn-outline-info btn-sm mt-1 px-3 mx-2" type="submit">Search</button>

        </li>
        
      
       
      </ul> */}
            <div className="ml-auto navbar-nav">
              <a href="#home" className=" animate__animated animate__bounceIn nav-link ">
                Home
              </a>
              <a href="#about" className=" animate__animated animate__bounceIn nav-link ">
                About
              </a>
              <a href="#wid" className=" animate__animated animate__bounceIn nav-link ">
                What I do?
              </a>
              <a href="#skills" className=" animate__animated animate__bounceIn nav-link ">
                Skills
              </a>
              <a href="#experience" className=" animate__animated animate__bounceIn nav-link ">
                Experience
              </a>
              <a href="#projects" className=" animate__animated animate__bounceIn nav-link ">
                Projects
              </a>
              <a href="#gallery" className=" animate__animated animate__bounceIn nav-link ">
                Portfolio
              </a>
              <a href="#contact" className=" animate__animated animate__bounceIn nav-link ">
                Contact
              </a>
              {/* <button
                type="button"
                onClick={ResumeBtn}
                className="header-action btn btn-outline-primary btn-sm px-2"
              >
                Resume
              </button> */}

              <Resume/>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default NavBar;
